<template>
  <div class="lazy-img" :style="customStyle">
    <div ref="padding" class="padding" :style="customStyle">
      <img src="../../../image/maizuo_padding.png"  :width="paddingImgWidth" alt="img">
    </div>
    <div ref="targetImg" class="lazy-img-wrap" :style="customStyle">
      <img :class="imgClass" v-lazyload="lazyloadOptions" src="">
    </div>
  </div>
</template>

<script>
  export default {
    name: 'lazy-img',
    props: {
      width: String,
      height: String,
      src: String,
      defaultImgWidth: {  // 当需要的 padding 宽度小于 64px 时才需要设置
        type: String,
        default: '64px'
      },
      background: {
        type: String,
        default: '#f9f9f9'
      }
    },
    data() {
      return {
        paddingImgWidth: this.defaultImgWidth
      }
    },
    computed: {
      imgClass() {
        return [
          'target-img',
          this.class || ''
        ]
      },
      customStyle() {
        // console.log('height---------->', this.height)
        return [
          {width: this.width},
          {height: this.height},
          {background: this.background}
        ]
      },
      lazyloadOptions() {
        return {
          src: this.rewriteLink(this.src),
          callback: this.onload
        }
      }
    },
    methods: {
      onload() {
        const paddingEl = this.$refs.padding
        const imgEl = this.$refs.targetImg
        fadeInOut(imgEl, paddingEl)
      },
      rewriteLink(link) {
        const aliyunCDN = /\.maizuo\.com/
        if (aliyunCDN.test(link)) {
          if (link.indexOf('?') !== -1) {
            return `${link}&x-oss-process=image/quality,Q_70`
          }
          return `${link}?x-oss-process=image/quality,Q_70`
        }
        return link
      }
    },
    directives: {
      lazyload: {
        bind: (el, binding) => {
          let img = new Image()
          img.src = binding.value.src
          img.onload = () => {
            el.src = img.src
            binding.value.callback()
          }
        },
        componentUpdated: (el, binding) => {
          let img = new Image()
          img.src = binding.value.src
          img.onload = () => {
            el.src = img.src
            binding.value.callback()
          }
        },
      }
    }
  }

  function fadeInOut(newElm, oldEl) {
    if (!newElm) {
      return
    }
    newElm.style.opacity = 0
    newElm.style.display = "block"

    ;(function fade() {
      let val = parseFloat(newElm.style.opacity)
      if (!((val += .1) > 1)) {
        newElm.style.opacity = val
        setTimeout(fade, 40)
      } else {
        // oldEl.parentNode.removeChild(oldEl)
      }
    })()
  }
</script>

<style lang="less" scoped>

.lazy-img {
  position: relative;
  .padding {
    background: rgb(244,244,244);
    height: calc(~'(420 / 750) * 100vw'); // 默认为 banner 的宽高比
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .lazy-img-wrap {
    height: calc(~'(420 / 750) * 100vw'); // 默认为 banner 的宽高比
    width: 100%;
    background: #ffffff;
    position: absolute;
    overflow: hidden;
    top: 0;
    opacity: 0;
    display: flex;
    justify-content: center;
    align-items: center;
    img{
      left: 0;
    }
    .target-img {
      width: 100%;
      position: absolute;
      top: 50%;
      transform: translateY(-50%);
      -ms-transform: translateY(-50%);
      -moz-transform: translateY(-50%);
      -webkit-transform: translateY(-50%);
      -o-transform: translateY(-50%);
    }
  }
}
</style>
